import Vue from "vue";
export const actions = {
  pushNotification(payload) {
    console.log("sdafsdf", payload);
    Vue.notify({
      type: payload.type,
      group: "foo",
      title: payload.title,
      text: payload.message,
      position: "bottom right",
      duration: 10000,
      speed: 500,
    });
  },
};
